import {
  GenerateQuestionsDto,
  QuestionDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { DOMAIN_DOUBLE_MATERIALITY } from "../domain";

import { roleGuard } from "@api";
import { doubleMaterialityQuestionsApi } from "@api/services";

const allowedRoles = [UserRole.Manager, UserRole.Owner];
const ACTION_GET_QUESTIONS = "GET_QUESTIONS";

export const useGenerateQuestions = (
  user: UserProfileDto | null,
): {
  generateQuestions: (dto: GenerateQuestionsDto) => Promise<QuestionDto[]>;
  isPendingGenerateQuestions: boolean;
  generateQuestionsEnabled: boolean;
} => {
  const queryClient = useQueryClient();
  const enabled = roleGuard(user, allowedRoles);

  const mutation = useMutation({
    mutationFn: async (dto: GenerateQuestionsDto): Promise<QuestionDto[]> => {
      const response =
        await doubleMaterialityQuestionsApi.doubleMaterialityQuestionsControllerGenerateQuestions(
          dto,
        );

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_DOUBLE_MATERIALITY, ACTION_GET_QUESTIONS],
      });
    },
  });

  return {
    generateQuestions: mutation.mutateAsync,
    isPendingGenerateQuestions: mutation.isPending,
    generateQuestionsEnabled: enabled,
  };
};
